module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"update_billplz":"Update Billplz","api_key":{"label":"API key","placeholder":"Write your Billplz secret key here"},"signature_key":{"label":"XSignature Key","placeholder":"Write your XSignature payment key here"},"collection_id":{"label":"Collection id","placeholder":"Write your collection id here"},"payment_channel":"Payment channel","credit_debit_card":"Credit / Debit Card"}}')
  delete Component.options._Ctor
}
